"use client";
import { useState, useEffect } from "react";

const useElementOnScreen = (
  ref,
  dependency,
  options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  },
  dependencies = []
) => {
  const [is_visible, set_is_visible] = useState(false);

  const callbackFunction = (entries) => {
    const [entry] = entries;
    const _is_visible = entry.isIntersecting;

    set_is_visible(_is_visible);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);

    if (ref) {
      if (ref.current && observer) {
        observer.observe(ref?.current);
      }
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, [dependency, ...dependencies]);

  return is_visible;
};

export default useElementOnScreen;
